module.exports = __webpack_public_path__ + "static/media/plus.bbc0f85d.svg";